import React from 'react';
import './customer-image-overlay.scss';
import PropTypes, { string } from 'prop-types';
import { Rating } from '@thd-olt-component-react/rating';
import { Row, Col } from '@thd-olt-component-react/grid';
import ImageOverlayModel from '../models/ImageOverlayModel';
import { MainImage } from './MainImage';
import ArrowButtons from './ArrowButtons';

class CustomerImageOverlay extends React.Component {

  static interactionTypes = {
    CLICK_NEXT: 'main-img-click-next',
    CLICK_PREVIOUS: 'main-img-click-previous',
    SWIPE_NEXT: 'main-img-swipe-next',
    SWIPE_PREVIOUS: 'main-img-swipe-previous',
    THUMBNAIL_CLICK: 'thumbnail-img-click',
  }

  imageOverlayModel = new ImageOverlayModel(
    // eslint-disable-next-line react/destructuring-assignment
    this.props.photos,
    // eslint-disable-next-line react/destructuring-assignment
    this.props.selectedPhotoID,
    // eslint-disable-next-line react/destructuring-assignment
    this.props.loopPhotos
  );

  thumbnailsRef = React.createRef();

  state = {
    selected: this.imageOverlayModel.selected.value
  };

  componentDidMount() {
    const { props } = this;
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('customer-image-overlay.ready');
    if (this.imageOverlayModel.errors) {
      props.onClose();
    }
  }

  componentDidUpdate() {
    const { channel } = this.props;
    if (channel === 'desktop') {
      this.scrollIntoView();
    }
  }

  nextImage = () => {
    const next = this.imageOverlayModel.selectNextImage();
    if (next) this.setState({ selected: next });
  };

  previousImage = () => {
    const previous = this.imageOverlayModel.selectPreviousImage();
    if (previous) this.setState({ selected: previous });
  };

  selectImageById = (id) => {
    const newSelected = this.imageOverlayModel.selectImageByID(id);
    this.setState({ selected: newSelected });
  }

  scrollIntoView = () => {
    const element = this.thumbnailsRef.current
      && this.thumbnailsRef.current.querySelector('.highlighted-image');

    if (element && element.scrollIntoView) {
      element.scrollIntoView();
    }
  }

  interactionHandler = (interactionType) => {
    const { props } = this;
    try {
      props.onInteraction(interactionType);
      // eslint-disable-next-line no-empty
    } catch (error) {}
  }

  render() {

    if (this.imageOverlayModel.errors) {
      return null;
    }

    const { selected } = this.state;
    const { onClose } = this.props;
    const currentImageNumber = selected.i + 1;
    const totalImages = this.imageOverlayModel.totalImages;
    const reviewText = selected.review.ReviewText;
    const { Title, UserNickname, SubmissionTime } = selected.review;
    const rating = selected.review.Rating;
    let displayDate = new Date(Date.parse(SubmissionTime));
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    displayDate = displayDate.toLocaleDateString('en-US', options);
    const photoUrl = selected.photo.Sizes.normal.Url;
    const reviewPhotos = selected.review.Photos.map((photo) => {
      return {
        photoId: photo.Id,
        url: photo.Sizes.thumbnail.Url
      };
    });

    const { CLICK_PREVIOUS, CLICK_NEXT, THUMBNAIL_CLICK } = CustomerImageOverlay.interactionTypes;

    return (
      <div className="customer-image-overlay" ref={this.thumbnailsRef}>
        <Row>
          <Col>
            <span className="customer-image-overlay__header">
              Customer Images
            </span>
            <span className="customer-image-overlay__ratio">
              ({currentImageNumber} of {totalImages})
            </span>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault();
                onClose(event);
              }}
              className="close-button"
            >
              Close
              <button type="button">
                <img
                  className="close-button__icon"
                  src="https://assets.homedepot-static.com/images/v1/close-symbol-orange.svg"
                  alt="Close"
                />
              </button>
            </a>
          </Col>
        </Row>
        <Row>
          <Col xs={6} nopadding className="main-image">
            {
              this.imageOverlayModel.hasPreviousImage()
                && (
                  <ArrowButtons
                    className="arrow"
                    direction="left"
                    onClick={() => {
                      this.previousImage();
                      this.interactionHandler(CLICK_PREVIOUS);
                    }}
                  />
                )
            }
            {
              this.imageOverlayModel.hasNextImage()
                && (
                  <ArrowButtons
                    className="arrow"
                    direction="right"
                    onClick={() => {
                      this.nextImage();
                      this.interactionHandler(CLICK_NEXT);
                    }}
                  />
                )
            }
            <MainImage
              photoUrl={photoUrl}
              getNextImage={this.nextImage}
              getPreviousImage={this.previousImage}
              interactionTypes={CustomerImageOverlay.interactionTypes}
              interactionHandler={this.interactionHandler}
            />
          </Col>
          <Col xs={6}>
            <Col flatten className="customer-image-overlay__review-specifics">
              <Col className="customer-image-overlay__review-specifics-container">
                <Col flatten className="review-title">
                  {Title}
                </Col>
                <Col style={{ display: 'flex', flexFlow: 'column' }}>

                  <Rating value={rating} />
                  <Col nopadding className="user-and-date">
                    by
                    <span style={{ fontWeight: 'bold' }}> {UserNickname} </span>
                    on
                    <span style={{ fontWeight: 'bold' }}> {displayDate} </span>
                  </Col>
                </Col>
                <Col className="review-text">
                  {reviewText}
                </Col>
              </Col>
              <Col className="images-collection-container">
                <br />
                <Col className="images-title ">
                  Images in This Review
                </Col>
                <br />
                <Row className="images-thumbnail-collection">
                  {
                    reviewPhotos.map(({ photoId, url }) => {
                      return (
                        <div
                          key={photoId}
                          className={this.state
                          && selected
                          && selected.photo
                          && selected.photo.Id === photoId ? 'highlighted-image' : 'image-thumbnail'}
                        >
                          <button
                            type="button"
                            onClick={
                              () => {
                                this.selectImageById(photoId);
                                this.interactionHandler(THUMBNAIL_CLICK);
                              }
                            }
                          >
                            <img
                              className="image-thumbnail-img"
                              src={url}
                              alt="thumbnail"
                            />
                          </button>
                        </div>
                      );
                    })
                  }
                </Row>
              </Col>
            </Col>
          </Col>
        </Row>
      </div>
    );
  }
}

CustomerImageOverlay.propTypes = {
  channel: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  photos: PropTypes.instanceOf(Object),
  selectedPhotoID: PropTypes.string,
  loopPhotos: PropTypes.bool,
  onInteraction: PropTypes.func,
};

CustomerImageOverlay.defaultProps = {
  channel: 'desktop',
  loopPhotos: false,
  photos: {},
  selectedPhotoID: null,
  onInteraction: () => {},
};

export { CustomerImageOverlay };
